import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminAuth.css';

export default function AdminAuth() {
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (password === 'hello') {
      navigate('/admin');
    } else {
      alert('Incorrect password');
    }
  };

  return (
    <div className="admin-auth">
      <div className="auth-box">
        <h2>Admin Access</h2>
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          placeholder="Enter password"
        />
        <button onClick={handleSubmit}>Enter</button>
      </div>
    </div>
  );
}
